<template>
  <div class="helper-wrapper">
    <div class="help-btn" @click="handleHelperClick">
      <span class="left-side v-h-center">{{
        $t('text.help').toUpperCase()
      }}</span>
      <span class="right-side v-h-center">
        <img src="@/assets/image/question-circle.svg" />
      </span>
    </div>
    <el-dialog
      :title="title"
      class="help-dialog"
      width="90vw"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      v-if="dialogVisible"
      :append-to-body="true"
      @close="closeDialog"
    >
      <div slot="title" v-html="title" class="el-dialog__title"></div>
      <div class="feature-container mb-20">
        <el-carousel
          arrow="always"
          height="600px"
          :interval="7000"
          :class="features.length === 1 ? 'signle-feature' : ''"
        >
          <el-carousel-item
            v-for="feature in features"
            :key="feature.title + feature.order"
          >
            <div class="feature-item">
              <div class="feature-animation">
                <img :src="feature.animation" />
              </div>
              <div class="feature-content">
                <div class="feature-title" v-html="feature.title"></div>
                <div class="feature-desc" v-html="feature.desc"></div>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialogVisible: false
    }
  },
  computed: {
    title() {
      let title
      switch (this.$route.path) {
        case '/patients/monitor':
          title = this.$t('text.patient_landing_slide1_title')
          break
        case '/patients/voiding-chart':
          title = this.$t('text.voiding_chart_help_dialog_title')
          break
        case '/patients/smartz-events-chart':
          title = this.$t('text.events')
          break
        case '/patients/pad-fill-profile-chart':
          title = this.$t('text.pad_fill_profile_chart_help_dialog_title', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
          })
          break
        case '/patients/position-chart':
          title = this.$t('text.position_chart_help_dialog_title')
          break
        case '/patients/smartz-devices':
          title = 'Using the Smartz™ Devices Chart'
          break
        case '/patients/pad-fill-profile-goal':
          title = this.$t('text.pad_fill_profile_goal_help_dialog_title', {
            pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
          })
          break
        case '/patients/skin-care-goal':
          title = this.$t('text.skin_care_goal_help_dialog_title')
          break
        case '/patients/position-goal':
          title = this.$t('text.position_goal_help_dialog_title')
          break
        case '/patients/temperature-goal':
          title = this.$t('text.temperature_goal_help_dialog_title')
          break
        case '/patients/fall-detection-goal':
          title = this.$t('text.fall_detection_goal_help_dialog_title')
          break
        case '/manage/organisation-profile':
          title = 'Organisation Profile'
          break
        case '/manage/buildings-rooms':
          title = 'Buildings & Rooms'
          break
        case '/manage/manufacturers':
          title = 'Manufacturers'
          break
        case '/manage/network-map':
          title = 'Network Map'
          break
        case '/manage/admin-permissions':
          title = 'Roles & Permissions'
          break
        case '/manage/organisation-setting':
          title = 'Organisation Setting'
          break
        case '/manage/my-account':
          title = 'Account'
          break
        case '/manage/user-accounts':
          title = 'User Accounts'
          break
        case '/manage/invite-user':
          title = 'Invite User'
          break
        case '/manage/patient-list':
          title = 'Patients'
          break
        case '/manage/monitor-patient':
          title = 'Monitor Patient'
          break
        case '/manage/data-privacy':
          title = 'Data Privacy'
          break
        case '/manage/devices-pods':
          title = 'Pods'
          break
        case '/manage/devices-nodes':
          title = 'Nodes'
          break
        case '/manage/report':
          title = 'Report'
          break
        case '/manage/report-history':
          title = 'Report History'
          break
        case '/manage/admin-algorithms':
          title = 'ADMIN - ALGORITHMS'
          break
        case '/manage/admin-data-privacy':
          title = 'ADMIN - DATA PRIVACY'
          break
        case '/manage/admin-customization':
          title = 'Customization Settings'
          break
        case '/reports/generate':
          title = this.$t('text.generate_report')
          break
        case '/reports/history':
          title = this.$t('text.report_history')
          break
      }
      return title
    },
    features() {
      let features
      switch (this.$route.path) {
        case '/patients/monitor':
          features = [
            {
              order: 0,
              title: this.$t('text.select_a_patient', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              desc: this.$t(
                'text.view_a_patient_by_selecting_from_drop_down_menu',
                {
                  patient: this.$firstLetterCapitalize(
                    this.$store.state.locale.patient
                  )
                }
              ),
              animation: require('@/assets/image/useful-features/help/individual-dashboard-slide1.gif')
            }
          ]
          break
        case '/patients/voiding-chart':
          features = [
            {
              order: 0,
              title: this.$t('text.void_chart'),
              desc: this.$t('text.voiding_chart_slide1_content', {
                pad: this.$store.state.locale.pad,
                patients: this.$firstLetterCapitalize(
                  this.$store.state.locale.patients
                )
              }),
              animation: require('@/assets/image/useful-features/help/voiding-chart-slide1.gif')
            },
            {
              order: 1,
              title: this.$t('text.void_chart'),
              desc: this.$t('text.common_help_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/void-chart-dropdown.gif')
            },
            {
              order: 2,
              title: this.$t('text.void_chart'),
              desc: this.$t('text.chart_common_slide_content'),
              animation: require('@/assets/image/useful-features/help/void-chart-select-date.gif')
            },
            {
              order: 3,
              title: this.$t('text.void_chart'),
              desc: this.$t('text.voiding_chart_slide4_content'),
              animation: require('@/assets/image/useful-features/help/void-chart-filters.gif')
            },
            {
              order: 4,
              title: this.$t('text.void_chart'),
              desc: this.$t('text.voiding_chart_slide5_content', {
                pad: this.$store.state.locale.pad,
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/voiding-chart-slide5.gif')
            }
          ]
          break
        case '/patients/smartz-events-chart':
          features = [
            {
              order: 0,
              title: this.$t('text.events'),
              desc: this.$t('text.smartz_events_slide1_content', {
                pad: this.$store.state.locale.pad
              }),
              animation: require('@/assets/image/useful-features/help/smartz-events-slide1.png')
            }
          ]
          break
        case '/patients/pad-fill-profile-chart':
          features = [
            {
              order: 0,
              title: this.$t('text.pad_fill_profile', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.pad_fill_profile_chart_slide1_content', {
                pad: this.$store.state.locale.pad
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-profile-chart-slide1.gif')
            },
            {
              order: 1,
              title: this.$t('text.pad_fill_profile', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.common_help_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-dropdown.gif')
            },
            {
              order: 2,
              title: this.$t('text.pad_fill_profile', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.chart_common_slide_content'),
              animation: require('@/assets/image/useful-features/help/pad-fill-profile-chart-slide3.gif')
            },
            {
              order: 3,
              title: this.$t('text.pad_fill_profile', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.pad_fill_profile_chart_slide4_content', {
                pad: this.$store.state.locale.pad
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-filter.gif')
            },
            {
              order: 4,
              title: this.$t('text.pad_fill_profile', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.pad_fill_profile_chart_slide5_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                ),
                pad: this.$store.state.locale.pad
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-profile-chart-slide5.gif')
            }
          ]
          break
        case '/patients/position-chart':
          features = [
            {
              order: 0,
              title: this.$t('text.Body Position Chart'),
              desc: this.$t('text.body_position_chart_slide1_content'),
              animation: require('@/assets/image/useful-features/help/body-position-chart-slide1.gif')
            },
            {
              order: 1,
              title: this.$t('text.Body Position Chart'),
              desc: this.$t('text.common_help_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/body-position-chart-slide2.gif')
            },
            {
              order: 2,
              title: this.$t('text.Body Position Chart'),
              desc: this.$t('text.chart_common_slide_content'),
              animation: require('@/assets/image/useful-features/help/body-position-chart-slide3.gif')
            },
            {
              order: 3,
              title: this.$t('text.Body Position Chart'),
              desc: this.$t('text.body_position_chart_slide4_content'),
              animation: require('@/assets/image/useful-features/help/body-position-chart-filter.gif')
            },
            {
              order: 4,
              title: this.$t('text.Body Position Chart'),
              desc: this.$t('text.body_position_chart_slide5_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/body-position-chart-slide5.gif')
            }
          ]
          break
        case '/patients/position-goal':
          features = [
            {
              order: 0,
              title: this.$t('text.body_position_goal_help_title'),
              desc: this.$t('text.body_position_goal_slide1_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/body-position-goal-slide1.gif')
            },
            {
              order: 1,
              title: this.$t('text.body_position_goal_help_title'),
              desc: this.$t('text.body_position_goal_slide2_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/body-position-dropdown.gif')
            },
            {
              order: 2,
              title: this.$t('text.body_position_goal_help_title'),
              desc: this.$t('text.body_position_goal_slide3_content', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              animation: require('@/assets/image/useful-features/help/body-position-goal-slide3.gif')
            }
          ]
          break
        case '/patients/skin-care-goal':
          features = [
            {
              order: 0,
              title: this.$t('text.skin_management_goal_help_title'),
              desc: this.$t('text.skin_management_goal_slide1_content', {
                pad: this.$store.state.locale.pad,
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/skin-care-goal-slide1.png')
            },
            {
              order: 1,
              title: this.$t('text.skin_management_goal_help_title'),
              desc: this.$t('text.skin_management_goal_slide2_content', {
                pad: this.$store.state.locale.pad,
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/skin-care-goal-slide2.gif')
            },
            {
              order: 2,
              title: this.$t('text.skin_management_goal_help_title'),
              desc: this.$t('text.skin_management_goal_slide3_content', {
                pad: this.$store.state.locale.pad,
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/skin-care-goal-slide3.gif')
            }
          ]
          break
        case '/patients/temperature-goal':
          features = [
            {
              order: 0,
              title: this.$t('text.pod_temperature_goal_help_title'),
              desc: this.$t('text.pod_temperature_goal_slide1_content', {
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/temperature-goal-slide1.gif')
            },
            {
              order: 1,
              title: this.$t('text.pod_temperature_goal_help_title'),
              desc: this.$t('text.pod_temperature_goal_slide2_content', {
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/temperature-goal-slide2.gif')
            },
            {
              order: 2,
              title: this.$t('text.pod_temperature_goal_help_title'),
              desc: this.$t('text.pod_temperature_goal_slide3_content'),
              animation: require('@/assets/image/useful-features/help/temperature-goal-slide3.gif')
            }
          ]
          break
        case '/patients/pad-fill-profile-goal':
          features = [
            {
              order: 0,
              title: this.$t('text.pad_fill_profile_goal_help_title', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.pad_fill_profile_goal_slide1_content', {
                pad: this.$store.state.locale.pad,
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-profile-goal-slide1.gif')
            },
            {
              order: 1,
              title: this.$t('text.pad_fill_profile_goal_help_title', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.pad_fill_profile_goal_slide2_content', {
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-profile-goal-slide2.gif')
            },
            {
              order: 2,
              title: this.$t('text.pad_fill_profile_goal_help_title', {
                pad: this.$firstLetterCapitalize(this.$store.state.locale.pad)
              }),
              desc: this.$t('text.pad_fill_profile_goal_slide3_content', {
                pad: this.$store.state.locale.pad,
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/pad-fill-profile-goal-slide3.gif')
            }
          ]
          break
        case '/patients/fall-detection-goal':
          features = [
            {
              order: 0,
              title: this.$t('text.fall_detection_goal_help_title'),
              desc: this.$t('text.fall_detection_goal_slide1_content', {
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/falls-goal-slide2.gif')
            },
            {
              order: 1,
              title: this.$t('text.fall_detection_goal_help_title'),
              desc: this.$t('text.fall_detection_goal_slide2_content', {
                patient: this.$store.state.locale.patient
              }),
              animation: require('@/assets/image/useful-features/help/falls-goal-dropdown.gif')
            },
            {
              order: 2,
              title: this.$t('text.fall_detection_goal_help_title'),
              desc: this.$t('text.fall_detection_goal_slide3_content'),
              animation: require('@/assets/image/useful-features/help/falls-goal-slide4.gif')
            }
          ]
          break
        default:
          features = [
            {
              order: 0,
              title: this.$t('text.select_a_patient', {
                patient: this.$firstLetterCapitalize(
                  this.$store.state.locale.patient
                )
              }),
              desc: this.$t(
                'text.view_a_patient_by_selecting_from_drop_down_menu',
                {
                  patient: this.$firstLetterCapitalize(
                    this.$store.state.locale.patient
                  )
                }
              ),
              animation: require('@/assets/image/useful-features/help/individual-dashboard-slide1.gif')
            }
          ]
      }
      return features
    }
  },
  methods: {
    closeDialog() {
      this.dialogVisible = false
    },
    handleHelperClick() {
      if (
        this.$route.path == '/dashboard' ||
        this.$route.path == '/care-plus-dashboard'
      ) {
        this.$router.push({ path: '/dashboard/landing' })
      } else if (this.$route.path == '/dashboard/landing') {
        this.$router.push({ path: '/care-plus-dashboard' })
      } else {
        this.dialogVisible = true
      }
    }
  }
}
</script>
